<template>
  <div class="point_index">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'PointNetridecash'
}
</script>
